import {User} from "~/dto/User";
import {User as UserApi} from "~/api/User";

export class UserService {

    user: Promise<User | null> | null = null;
    tryFetch: boolean = true;

    static getInstance(): UserService {
        return useState<UserService>("userService", () => new UserService()).value;
    }

    private async fetchUser(): Promise<void> {
        if (import.meta.server) return;
        this.user = UserApi.getInfo();
    }

    async getCurrent(): Promise<User | null> {
        if (this.tryFetch) {
            this.tryFetch = false;
            await this.fetchUser();
        }

        return this.user;
    }

}